<template>
  <div class="field-group" :class="{ 'has-error': !!error }">
    <div class="field-heading">
      <label v-if="label" @click="toggle()" :class="{ 'required': required }">
        {{ label }}
      </label>
    </div>

    <on-click-outside v-if="hasPermission" :do="close">
      <div class="search-select" :class="{ 'is-active': isOpen }">
        <button ref="button" @click="toggle()" type="button" class="search-select-input">
          <span v-if="value">{{ value.name }}</span>
          <span v-else class="search-select-placeholder">Selecteer...</span>
        </button>
        <div v-show="isOpen" class="search-select-dropdown">
          <input v-if="searching"
            class="search-select-search"
            v-model="search"
            ref="search"
            @keydown.esc="close()"
            @keydown.up="highlightPrev()"
            @keydown.down="highlightNext()"
            @keydown.enter.prevent="selectHighlighted()"
            @keydown.tab.prevent
          />
          <ul ref="options" v-show="filteredOptions.length > 0" class="search-select-options">
            <li class="search-select-option" v-if="deselect" @click="select(null)">Verwijder keuze</li>
            <li class="search-select-option" :class="{ 'is-active': index === highlighted }"
              v-for="(option, index) in filteredOptions"
              :key="index"
              @click="select(option)"
            >{{ option.name }}</li>
          </ul>
          <div v-show="filteredOptions.length === 0" class="search-select-empty">
            Geen resultaten gevonden voor "{{ search }}"
          </div>
        </div>
        <transition name="slide">
          <span v-if="error" class="block form-error text-xs">
            {{ error }}
          </span>
        </transition>
      </div>
    </on-click-outside>

    <div v-else class="readonly">
      <span v-if="value">{{ value.name }}</span>
      <span v-else>-</span>
    </div>
  </div>
</template>

<script>
import OnClickOutside from '@/components/globals/OnClickOutside';

export default {
  $_veeValidate: {
    name() {
      return this.label;
    },
    value() {
      return this.value;
    }
  },
  inject: ['$validator'],
  components: {
    OnClickOutside
  },
  props: {
    value: {
      required: true
    },
    label: String,
    options: {
      type: Array,
      default: () => []
    },
    required: {
      type: Boolean,
      default: false
    },
    hasPermission: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      required: false
    },
    searching: {
      type: Boolean,
      default: false
    },
    deselect: {
      type: Boolean,
      default: true
    },
    filterFunction: {
      type: Function,
      required: false
    }
  },
  data() {
    return {
      isOpen: false,
      search: '',
      highlighted: 0
    };
  },
  computed: {
    placeholder() {
      return `Selecteer een ${this.label.toLowerCase()}`;
    },
    filteredOptions() {
      if (!this.options) {
        return [];
      }

      let options = this.options;

      if (this.filterFunction) {
        return this.filteredOptions(this.search, options);
      }

      return options.filter(option => {
        return option.name.toLowerCase().includes(this.search.toLowerCase());
      });
    }
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;

      if (this.isOpen) {
        return this.open();
      }
      return this.close();
    },
    open() {
      if (this.isOpen) {
        return;
      }

      this.isOpen = true;
      this.$nextTick(() => {
        if (this.searching) {
          this.$refs.search.focus();
        }
        this.scrollToHighlighted();
      });
    },
    close() {
      if (!this.isOpen) {
        return;
      }

      this.isOpen = false;
      this.$refs.button.focus();
    },
    select(option) {
      this.$emit('input', option);
      this.$emit('changed', option);
      this.search = '';
      this.highlighted = 0;
      this.close();
    },
    selectHighlighted() {
      this.select(this.filteredOptions[this.highlighted]);
    },
    scrollToHighlighted() {
      this.$refs.options.children[this.highlighted].scrollIntoView({
        block: 'nearest'
      });
    },
    highlight(index) {
      this.highlighted = index;
      const length = this.filteredOptions.length - 1;

      if (this.highlighted < 0) {
        this.highlighted = length;
      }

      if (this.highlighted > length) {
        this.highlighted = 0;
      }

      this.scrollToHighlighted();
    },
    highlightPrev() {
      this.highlight(this.highlighted - 1);
    },
    highlightNext() {
      this.highlight(this.highlighted + 1);
    }
  }
};
</script>
